import { useLocalStorage } from 'react-use';
import { Location } from 'react-router-dom';

export function useSaveLocation() {
  return useLocalStorage<Location>('application-redirect-location');
}
